import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEuropeanUnionFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0005 1.11397e-08C35.934 0.0001093 41.7341 1.75968 46.6675 5.0562C51.6009 8.35272 55.446 13.0381 57.7166 18.5199C59.9871 24.0017 60.5811 30.0337 59.4235 35.8531C58.2658 41.6725 55.4085 47.018 51.2129 51.2135C47.0173 55.409 41.6718 58.2661 35.8523 59.4236C30.0329 60.5811 24.0009 59.9869 18.5192 57.7162C13.0374 55.4456 8.35212 51.6003 5.05574 46.6668C1.75935 41.7333 -5.53905e-05 35.9331 1.30789e-09 29.9997C1.98796e-06 26.06 0.775996 22.1589 2.28368 18.5191C3.79136 14.8793 6.00119 11.5722 8.78701 8.78642C11.5728 6.00068 14.8801 3.79094 18.5199 2.28336C22.1597 0.775779 26.0609 -0.000107347 30.0005 1.11397e-08V1.11397e-08Z",
			fill: "#2A5F9E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0024 9.80103L30.7192 12.006H33.0374L31.1624 13.3689L31.877 15.5739L30.0024 14.211L28.1251 15.5739L28.842 13.3689L26.9666 12.006H29.2852L30.0024 9.80103Z",
			fill: "#FFCE31"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0005 43.7778L30.7173 45.984H33.0374L31.1601 47.348L31.877 49.553L30.0005 48.189L28.1251 49.553L28.842 47.348L26.9666 45.984H29.2852L30.0005 43.7778Z",
			fill: "#FFCE31"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.4201 41.032L39.1369 43.2393H41.4566L39.5801 44.6021L40.2973 46.8068L38.4201 45.4435L36.5451 46.8068L37.2627 44.6021L35.3858 43.2393H37.7044L38.4201 41.032Z",
			fill: "#FFCE31"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.221 35.2332L44.9383 37.4393H47.256L45.3796 38.8029L46.0964 41.0079L44.221 39.645L42.3438 41.0079L43.0614 38.8029L41.1864 37.4393H43.5042L44.221 35.2332Z",
			fill: "#FFCE31"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.9653 26.7888L47.6822 28.9946H50.0003L48.125 30.3578L48.8411 32.5628L46.9653 31.1996L45.0896 32.5628L45.8049 30.3578L43.9307 28.9946H46.2481L46.9653 26.7888Z",
			fill: "#FFCE31"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.221 18.344L44.9383 20.5513H47.256L45.3796 21.9142L46.0964 24.1191L44.221 22.7559L42.3438 24.1191L43.0614 21.9142L41.1864 20.5513H43.5042L44.221 18.344Z",
			fill: "#FFCE31"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.4202 12.5457L39.137 14.7518H41.4567L39.5802 16.1147L40.2974 18.3201L38.4202 16.9572L36.5452 18.3201L37.2613 16.1147L35.3856 14.7518H37.7045L38.4202 12.5457Z",
			fill: "#FFCE31"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5799 41.032L20.8635 43.2393H18.5453L20.421 44.6021L19.7042 46.8068L21.5799 45.4435L23.4572 46.8068L22.7403 44.6021L24.6149 43.2393H22.2975L21.5799 41.032Z",
			fill: "#FFCE31"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7813 35.2332L15.0637 37.4393H12.7463L14.6224 38.8029L13.9056 41.0079L15.7813 39.645L17.6567 41.0079L16.9406 38.8029L18.8163 37.4393H16.4981L15.7813 35.2332Z",
			fill: "#FFCE31"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.0361 26.7888L12.3204 28.9946H10L11.8757 30.3578L11.16 32.5628L13.0361 31.1996L14.9122 32.5628L14.1962 30.3578L16.0711 28.9946H13.7526L13.0361 26.7888Z",
			fill: "#FFCE31"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7813 18.344L15.0637 20.5513H12.7463L14.6224 21.9142L13.9056 24.1191L15.7813 22.7559L17.6567 24.1191L16.9406 21.9142L18.8163 20.5513H16.4981L15.7813 18.344Z",
			fill: "#FFCE31"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5799 12.5457L20.8642 14.7518H18.5453L20.421 16.1147L19.7053 18.3201L21.5799 16.9572L23.4572 18.3201L22.7403 16.1147L24.6149 14.7518H22.2975L21.5799 12.5457Z",
			fill: "#FFCE31"
		})
	]
});
export default SvgEuropeanUnionFlag;
